"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CenteredSpinner = exports.AbsoluteCenteredSpinner = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _alloyReactProgressRing = _interopRequireDefault(require("@adsk/alloy-react-progress-ring"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledCenterSpinnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "CenteredSpinner__StyledCenterSpinnerWrapper",
  componentId: "sc-g1pq20-0"
})(["display:flex;align-items:center;justify-content:center;position:relative;top:50%;transform:translateY(-50%);"]);
const StyledAbsoluteSpinnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "CenteredSpinner__StyledAbsoluteSpinnerWrapper",
  componentId: "sc-g1pq20-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);", ""], props => props.zIndex ? "z-index: ".concat(props.zIndex, ";") : "");
const CenteredSpinner = function () {
  let {
    size = _alloyReactProgressRing.default.SIZES.MEDIUM
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/React.createElement(StyledCenterSpinnerWrapper, null, /*#__PURE__*/React.createElement(_alloyReactProgressRing.default, {
    size: size
  }));
};
exports.CenteredSpinner = CenteredSpinner;
const AbsoluteCenteredSpinner = function () {
  let {
    size = _alloyReactProgressRing.default.SIZES.MEDIUM,
    zIndex,
    delay
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [showSpinner, setShowSpinner] = (0, _react.useState)(!delay);
  (0, _react.useEffect)(() => {
    if (!delay) return;
    const timeout = setTimeout(() => {
      setShowSpinner(true);
    }, delay);
    return () => {
      clearTimeout(timeout);
    };
  }, [delay]);
  return showSpinner ? /*#__PURE__*/React.createElement(StyledAbsoluteSpinnerWrapper, {
    zIndex: zIndex
  }, /*#__PURE__*/React.createElement(_alloyReactProgressRing.default, {
    size: size
  })) : null;
};
exports.AbsoluteCenteredSpinner = AbsoluteCenteredSpinner;
//# sourceMappingURL=CenteredSpinner.js.map